/*
  ReelDope hotfix — 2026-09-04

  Shopify's hosted option_selection.js (loaded via `shopify_asset_url`) was
  redeployed wrapped in "use strict". Its Shopify.Product.prototype.update uses
  an undeclared loop variable (`for (property in json)`), which throws
  "ReferenceError: property is not defined" in strict mode. That aborts
  Turbo's runOptionSelector() and the rest of the theme boot sequence, leaving
  the product form (price, swatches, Add to Cart) at opacity 0.

  This file must be loaded with `defer` immediately after option_selection.js
  so it runs after Shopify's file has defined Shopify.Product and before the
  theme's DOM-ready handlers call Shopify.OptionSelectors.

  Behaviour is identical to Shopify's original implementation. Safe to leave
  in place if Shopify fixes their file; remove once they have.
*/
(function () {
  if (!window.Shopify || typeof window.Shopify.Product !== 'function') {
    return;
  }
  window.Shopify.Product.prototype.update = function (json) {
    for (var property in json) {
      this[property] = json[property];
    }
  };
})();
